import { Dialog, Button, DialogContent, DialogActions } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Exclamation } from '@/common/icons/Exclamation';

const useStyles: any = makeStyles(theme => ({
  content: {
    minHeight: 160,
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'center'
  },
  headingContainer: {
    margin: '0 auto 20px auto',
    width: 156
  },
  heading: {
    fontSize: 20,
    fontWeight: 600
  },
  circle1: {
    height: 64,
    width: 64,
    margin: '0 auto 20px auto',
    paddingLeft: 14,
    paddingTop: 14,
    backgroundColor: theme.palette.error[50],
    borderRadius: 31
  },
  circle2: {
    height: 36,
    width: 36,
    paddingLeft: 2,
    paddingTop: 2,
    backgroundColor: theme.palette.error[400],
    borderRadius: 31,
    '& svg': {
      height: 32,
      width: 32
    }
  },
  actions: {
    margin: '0 auto'
  }
}));

export interface AccessDeniedModalProps {
  okClick: () => void;
}

const AccessDeniedModal = ({ okClick }: AccessDeniedModalProps) => {
  const classes = useStyles();
  return (
    <Dialog fullWidth open={true}>
      <DialogContent className={classes.content}>
        <div className={classes.circle1}>
          <div className={classes.circle2}>
            <Exclamation color="#FFEBEE" />
          </div>
        </div>
        <div className={classes.headingContainer}>
          <p className={classes.heading}>Access Denied</p>
        </div>
        <p>
          The current user does not have permission to perform this function.
          Please obtain Manager approval to continue.
        </p>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={okClick} autoFocus variant="contained">
          {'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccessDeniedModal;
